var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShekelSign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M248 168V312C248 334.094 265.906 352 288 352S328 334.094 328 312V168C328 93.016 267 32 192 32H40C17.906 32 0 49.906 0 72V440C0 462.094 17.906 480 40 480S80 462.094 80 440V112H192C222.875 112 248 137.125 248 168ZM408 32C385.906 32 368 49.906 368 72V344C368 374.875 342.875 400 312 400H200V200C200 177.906 182.094 160 160 160S120 177.906 120 200V440C120 462.094 137.906 480 160 480H312C387 480 448 418.984 448 344V72C448 49.906 430.094 32 408 32Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShekelSign);
export default __webpack_public_path__ + "static/media/shekel-sign.cf840b025b2b775147d07850c89d9c51.svg";
export { ForwardRef as ReactComponent };